@let isValueInputDropdownDrawn =
  selectedOperatorConfiguration() && selectedOperatorConfiguration()?.type !== EFieldTypes.boolean;

<form class="advanced-filter-inputs" #form="ngForm" (ngSubmit)="submit()">
  <div class="chip d-flex flex-wrap gap-5 align-items-center py-2">
    <mat-dropdown
      [style.flex]="isValueInputDropdownDrawn ? '8 1 0' : '5 1 0'"
      [formControl]="formGroup.controls.field"
      [configurationInput]="fieldDropdownConfiguration"
      [options]="fieldDropdownOptions()"
      [isFormSubmitted]="form.submitted || isFormSubmitted()"
    ></mat-dropdown>

    <mat-dropdown
      #operatorDropdown
      [style.flex]="isValueInputDropdownDrawn ? '5 1 0' : '3 1 0'"
      [formControl]="formGroup.controls.operator"
      [configurationInput]="operatorDropdownConfiguration"
      [options]="operatorDropdownOptions()"
      [isFormSubmitted]="form.submitted || isFormSubmitted()"
    ></mat-dropdown>

    @if (
      selectedOperatorConfiguration()?.type === 'apiDropdown' ||
      selectedOperatorConfiguration()?.type === 'predefined' ||
      selectedOperatorConfiguration()?.type === 'customApiDropdown' ||
      selectedOperatorConfiguration()?.type === 'customPredefined'
    ) {
      <mat-dropdown
        #valueDropdown
        style="flex: 8 1 0"
        [formControl]="formGroup.controls.apiDropdownValue"
        [configurationInput]="apiDropdownConfiguration()"
        [options]="valueOptions()"
        [isFormSubmitted]="form.submitted || isFormSubmitted()"
        (search)="dropdownSearch($event)"
      ></mat-dropdown>
    }

    @if (
      selectedOperatorConfiguration()?.type === EFieldTypes.string ||
      selectedOperatorConfiguration()?.type === EFieldTypes.number
    ) {
      @let isNumber = selectedOperatorConfiguration()?.type === 'number';
      <mat-form-field style="flex: 8 1 0" appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'field.value' | translate }}</mat-label>
        <input
          matInput
          [formControl]="isNumber ? formGroup.controls.numberValue : formGroup.controls.stringValue"
          [type]="isNumber ? 'number' : 'string'"
        />
        <mat-error [control]="isNumber ? formGroup.controls.numberValue : formGroup.controls.stringValue"></mat-error>
      </mat-form-field>
    }

    @if (selectedOperatorConfiguration()?.type === 'date') {
      <app-date-range-picker
        style="flex: 8 1 0"
        [formControl]="formGroup.controls.dateRange"
        [isFormSubmitted]="form.submitted || isFormSubmitted()"
        [configurationInput]="{
          singleDatePicker:
            !!formGroup.controls.operator.value.length && formGroup.controls.operator.value[0].id !== '$between',
          showErrors: false,
          isTimePickerShown: false,
          label: this.isOptional() ? '' : ('field.date' | translate),
          drops: 'auto',
          opens: 'left',
          showClearButton: true,
          showRanges: true,
        }"
      ></app-date-range-picker>
    }

    @if (
      inputsConfiguration().mode === EAdvancedFilterInputMode.autoSubmitWithCancel ||
      inputsConfiguration().mode === EAdvancedFilterInputMode.submitButtonAndCancel
    ) {
      <button mat-mini-fab class="v-middle" (click)="dismissOrDelete()">
        <mat-icon>{{ (autoSubmit$ | async)?.isValid ? 'done' : 'delete' }}</mat-icon>
      </button>
    }

    @if (inputsConfiguration().mode === EAdvancedFilterInputMode.submitButtonAndCancel) {
      <button style="flex: 1 1 0" mat-flat-button type="submit">
        {{ (inputsConfiguration().type === 'add' ? 'button.add' : 'button.edit') | translate }}
      </button>
    }
  </div>
</form>
